export class RefreshToken {
  userName!:string
}
